import BaseModelAPI from '../BaseModelAPI';

export default class ProcessType extends BaseModelAPI {
	static entity = 'processtype';
	static entityName = 'processtype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}